<nav class="navbar navbar-inverse" [class.mojo-application-header]="showMojoNavHeader">
  <div class="container-fluid">
    <ul class="nav navbar-nav navbar-left">
      <li>
        <p-menu
        [styleClass]="systemMenuStyleClass"
        showTransitionOptions="0.25s cubic-bezier(0, 0, 0.2, 1)"
        appendTo="body" #menu [popup]="true" [model]="systemMenuItems | async"></p-menu>
        <a id="systemMenuIcon" alt="System Menu" title="Main Menu"><i class="fa fa-bars" aria-hidden="true" (click)="menu.toggle($event)"></i></a>
      <li>
    </ul>
    <div class="navbar-header">
      <ng-container *ngIf="showMojoNavHeader; then mojo_branding; else mci_branding">
      </ng-container>
      <ng-template #mci_branding>
        <a class="navbar-brand brand-name-image" [routerLink]="this.homepageUrl$ | async">
          <span class="brand-name"></span>
          <span class="app-name">{{appName$ | async}}</span>
        </a>
        <span class="navbar_mojo_logo">
          <div class="pull-left powered-by">powered by</div>
          <div class="pull-left"><i class="icon-mojo"></i></div>
        </span>
      </ng-template>

      <ng-template #mojo_branding>
        <div class="mojo-tribrand-logo">
          <img class="iconlogos" src="assets/brand/brands/mojo/iconlogos.png" /> with added <img class="mojo-logo" src="assets/brand/brands/mojo/logo-outlined-white.png" />
        </div>
      </ng-template>

    </div>

    <ul class="nav navbar-nav navbar-right">
      <li>
        <mojo-preview-mode-exit></mojo-preview-mode-exit>
      </li>

      <li *ngIf="showCircleIcons">
        <a id="homePageNavIcon" title="Home" [href]="(this.homepageUrl$ | async) ?? getActivityListUrl()"><p class="navbar-icon navbar-homepage-icon"></p></a>
      <li>

      <li *ngIf="showCircleIcons">
        <a id="myDashboardNavIcon" title="My Dashboard" routerLink="/main"><p class="navbar-icon navbar-mydashboard-icon"></p></a>
      <li>

      <li *ngIf="showCircleIcons && isWorksEnabled">
        <a id="worksNavIcon" title="My Works" [href]="getWorksUrl()"><p class="navbar-icon navbar-works-icon"></p></a>
      <li>

      <li *ngIf="showCircleIcons">
        <a id="myActivitiesNavIcon" title="My Activities" [href]="getActivityListUrl()"><p class="navbar-icon navbar-mojo-activity-icon"></p></a>
      <li>

      <li *ngIf="showCircleIcons">
        <a id="newActivityNavIcon" title="New Activity" [href]="getNewActivityUrl()"><p class="navbar-icon navbar-mojo-new-activity-icon"></p></a>
      <li>

      <li>
        <i *ngIf="showPasswordExpiryWarning()" class="warning-icon fa fa-exclamation-triangle" aria-hidden="true" (click)="passwordExpiryWarningClick($event)"></i>
        <p-menu
        [styleClass]="userMenuStyleClass"
        showTransitionOptions="0.25s cubic-bezier(0, 0, 0.2, 1)"
        appendTo="body" #umenu [popup]="true" [model]="userMenuItems | async"></p-menu>
        <span class="navbar-text" (click)="umenu.toggle($event)" title="User Menu"><span class="navbar-user-icon fa fa-user"></span>{{userName$ | async}}<span class="fa fa-caret-down navbar-user-menu-caret"></span></span>
      </li>
    </ul>
  </div>
  <mojo-about [(display)]="displayAboutDialog"></mojo-about>

</nav>
<mojo-contact-us></mojo-contact-us>
<mojo-product-preview *ngIf="isInMyDashboardMode"></mojo-product-preview>
